import { render } from "./Component.vue?vue&type=template&id=ad5e4f1c&ts=true"
import script from "./Component.vue?vue&type=script&lang=ts"
export * from "./Component.vue?vue&type=script&lang=ts"

import "./styles.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/www/apps/mydr/mydr-welcome/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__